"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-san-biagio": {
    "a451337f": [{
      "hkey": "a5bd2afe",
      "slug": "monte-san-biagio",
      "name": "Monte San Biagio",
      "primary": true,
      "skipSearch": false
    }],
    "vallemarina": [{
      "hkey": "a5bd2afe",
      "slug": "monte-san-biagio",
      "name": "Monte San Biagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02cccc8a": [{
      "hkey": "a5bd2afe",
      "slug": "monte-san-biagio",
      "name": "Monte San Biagio",
      "primary": true,
      "skipSearch": false
    }],
    "villa-san-vito": [{
      "hkey": "a5bd2afe",
      "slug": "monte-san-biagio",
      "name": "Monte San Biagio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;